import "react-phone-number-input/style.css";

import CustomPhoneInput from "./PhoneInput";
import PhoneInput from "react-phone-number-input/input";
import classes from "./validated-phone-input.module.css";

function ValidatedPhoneInput(props) {
  const { name, errorMessage, value, onChange, placeholder, labelName } = props;

  let style = {
    style: { textAlign: "center", fontSize: "1.3rem", height: "36px" },
    // Browser autofill: one-tap phone fill on mobile keyboards.
    autoComplete: "tel",
    inputMode: "tel",
  };

  return (
    <PhoneInput
      name={name}
      className={classes.phoneInput}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={errorMessage.length > 0}
      helpertext={errorMessage}
      label={labelName}
      defaultCountry="US"
      addInternationalOption={false}
      countries={["US"]}
      inputComponent={CustomPhoneInput}
      inputProps={style}
      sx={{
        "& .MuiInputLabel-root": {
          top: "6px",
        },
        "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiInputLabel-shrink":
          {
            top: "0",
          },
      }}
    />
  );
}

export default ValidatedPhoneInput;
